import { Consignment } from 'src/@core/models'
import { API } from './../config/api'
import { IConsignmentNotes, NoteType, INoteLog } from './models/consignment-notes.DTO'
import { IConsignmentCharges, IAdhocCharge } from './models/consignment-charges.DTO'
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { Router } from '@angular/router';
import {
  IConsignmentSummary,
  IConsignmentTracking,
  IConsignmentLabel,
  IConsignmentRecalculate,
  IConsignmentLog,
  IConsignmentPod,
  IConsignmentNote,
  IConsignmentEdit
} from './models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PaginationResponse, ErrorResponse } from '../config/common';
import { tap, catchError } from 'rxjs/operators';
import { BoSpinnerService } from 'src/@core/shared/spinner.service';
import { BoToastrService } from 'src/@core/shared/toastr.service';
import { SUCCESS } from 'src/@shared/constants';

@Injectable()
export class ConsignmentActionsService {

  constructor(
    private _router: Router,
    private _httpClient: HttpClient,
    private _spinner: BoSpinnerService,
    private _toastr: BoToastrService
  ) { }

  getConsignmentLog(id: string): Observable<PaginationResponse<IConsignmentLog>> {
    const params = new HttpParams()
      .append('ObjectId', id)
      .append('PaginationType', '-1');

    return this._httpClient.get<PaginationResponse<IConsignmentLog>>(API.AUDIT.GET, { params: params });
  }

  getConsignmentTracking(id): Observable<IConsignmentTracking> {
    const mockData: IConsignmentTracking = {
      status: 'On route delivering...'
    };

    const subject = new Subject<IConsignmentTracking>();

    setTimeout(() => {
      subject.next(mockData);
      subject.complete();
    }, 1000);

    return subject;
  }

  getConsignmentRecalculate(consignentId: string) {
    this._spinner.show();
    return this._httpClient.get(`${API.CONSIGNMENT.GET_RECALCULATE_CHARGE(consignentId)}`)
      .pipe(
        tap(() => {
          this._spinner.hide();
        }),
        catchError((err: ErrorResponse) => {
          this._spinner.hide();
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  recalculateConsignment(consignentId: string) {
    this._spinner.show();
    return this._httpClient
    .put(`${API.CONSIGNMENT.CALCULATE_CHARGE(consignentId)}`, null)
      .pipe(
        tap(() => {
          this._spinner.hide();
          this._toastr.successCode(SUCCESS.UPDATE_CONSIGNMENT);
        }),
        catchError((err: ErrorResponse) => {
          this._spinner.hide();
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  getConsignmentLabel(id): Observable<IConsignmentLabel> {
    const mockData: IConsignmentLabel = {
      account: 'AMC1493',
      consignmentNumber: '260554',
      netWeight: '0 kg',
      serviceLevel: 'Same day',
      carton: '1/1',
      cartonReference: '1/1',
      specialInstruction: 'No special instructions',

      deliveryTo: 'AALCO CHEPSTOW',
      deliveryAddress: 'NEWHOUSE FARM IND EST',
      deliveryPostcode: 'NP16 6UD',
      deliveryPhone: '190023343',

      sender: 'Phu',
      collectionAddress: 'NEWHOUSE FARM IND EST',
      collectionPostcode: 'NP16 6UD'
    };

    const subject = new Subject<IConsignmentLabel>();

    setTimeout(() => {
      subject.next(mockData);
      subject.complete();
    }, 1000);

    return subject;
  }

  getConsignmentPod(consignmentAdditionalDetailId): Observable<IConsignmentPod[]> {
    this._spinner.show(true);
    return this._httpClient.get<IConsignmentPod[]>(API.CONSIGNMENT.POD.GET_ALL(consignmentAdditionalDetailId)).pipe(tap(() => this._spinner.hide()));
  }

  updateConsignmentPod(consignmentAdditionalDetailId: string, podId: string, podFormData: FormData): Observable<IConsignmentPod> {
    return this._httpClient.put<IConsignmentPod>(API.CONSIGNMENT.POD.UPDATE(consignmentAdditionalDetailId, podId), podFormData);
  }

  createConsignmentPod(consignmentAdditionalDetailId: string, podFormData: FormData): Observable<IConsignmentPod> {
    return this._httpClient.post<IConsignmentPod>(API.CONSIGNMENT.POD.CREATE(consignmentAdditionalDetailId), podFormData);
  }

  getConsignmentCharges(id): Observable<PaginationResponse<IAdhocCharge>> {
    this._spinner.show(true);
    const params = new HttpParams().set('paginationtype', '-1');
    return this._httpClient.get<PaginationResponse<IAdhocCharge>>(API.CONSIGNMENT.GET_CHARGES(id), { params: params }).pipe(tap(() => this._spinner.hide()));
  }

  createConsignmentCharge(consignmentId: string, chargeModel: IAdhocCharge): Observable<IAdhocCharge> {
    return this._httpClient.post<IAdhocCharge>(API.CONSIGNMENT.CREATE_CHARGE(consignmentId), chargeModel);
  }

  deleteConsignmentCharge(consignmentId: string, chargeId: string): Observable<any> {
    return this._httpClient.delete(API.CONSIGNMENT.DELETE_CHARGE(consignmentId, chargeId));
  }

  updateConsignmentCharge(consignmentId: string, updatedCharge: IAdhocCharge): Observable<any> {
    return this._httpClient.put(API.CONSIGNMENT.UPDATE_CHARGE(consignmentId), updatedCharge);
  }

  getConsignmentNotes(id,internal): Observable<INoteLog[]> {
    this._spinner.show();
    return this._httpClient.get<INoteLog[]>(API.CONSIGNMENT_NOTE.GET_CONSIGNMENT_NOTE(id,internal)).pipe(tap(() => this._spinner.hide()));
  }

  createNewNote(newNote): Observable<INoteLog> {

    const mockData: INoteLog = {
      id: '123',
      createdDate: new Date(2019, 12, 12),
      note: newNote.note,
      type: newNote.type,
      createdBy: 'fwfwfw',
      consignmentId: '1111'
    };

    console.log(mockData);
    const subject = new Subject<INoteLog>();

    setTimeout(() => {
      subject.next(mockData);
      subject.complete();
    }, 1000);

    return subject;
  }

  deleteConsignment(id): Observable<any> {

    const mockData = {
      status: 'success'
    };

    const subject = new Subject();

    setTimeout(() => {
      subject.next(mockData);
      subject.complete();
    }, 1000);

    return subject;
  }

  cloneConsignment(cloneModel: { consignmentId: string, failureCode: string }): Observable<Consignment> {

    return this._httpClient.post<Consignment>(API.CONSIGNMENT.CLONE(cloneModel.consignmentId), { FailureCode: cloneModel.failureCode });
  }

  cloneRtsConsignment(consignmentId): Observable<Consignment> {

    return this._httpClient.post<Consignment>(API.CONSIGNMENT.CLONE_RTS(consignmentId), {});
  }

  copyConsignment(copyModel: { consignmentId: string, customerId: number }): Observable<Consignment> {

    return this._httpClient.post<Consignment>(API.CONSIGNMENT.COPY(copyModel.consignmentId), { customerId: copyModel.customerId });
  }

  getConsignmentDataToEdit(id: string): Observable<IConsignmentEdit> {
    this._spinner.show();
    return this._httpClient.get<IConsignmentEdit>(`${API.CONSIGNMENT.GET_ONE(id)}`).pipe(tap(() => this._spinner.hide()));
  }
  editConsignment(consignmentId: string, model: IConsignmentEdit): Observable<any> {
    return this._httpClient.put<any>(API.CONSIGNMENT.EDIT(consignmentId), model);
  }
}



